let configVersion = '';
try {
    configVersion = VERSION;
}
catch (e) {
    configVersion = String(Math.random());
}
export class AppConfig {
}
export class ConfigService {
    constructor() {
        this.currentValues = {};
        this.configUrl = `/conf/env.json?cb=${configVersion}`;
    }
    async load() {
        const response = await fetch(this.configUrl);
        if (response.status === 404) {
            return ConfigService.devConfig;
        }
        this.currentValues = await response.json().then(config => (Object.assign(Object.assign({}, ConfigService.devConfig), config)));
        return this.currentValues;
    }
}
ConfigService.devConfig = {
    isProd: false,
    apiUrl: 'https://webapi-staging.contentsquare.com',
    proxyUrl: 'https://proxy-staging.contentsquare.com',
    loginUrl: 'https://staging-login.contentsquare.com/',
    sessionPlayerUrl: 'https://player-staging.contentsquare.com',
    ctSessionPlayerUrl: 'http://session-replay-eu.contentsquare.com/?token=',
    consoleUrl: 'https://staging-console.contentsquare.com',
    translationUrl: 'https://i18n-staging.contentsquare.com/v1',
    featureFlags: {
        lokalise: false,
    },
    microFrontends: {},
    useCacheBusting: false,
    isSDK: false,
    timezoneId: '',
    currency: 'EUR',
    locale: 'en',
    isEcommerce: true,
};
//# sourceMappingURL=config.service.js.map